/**
 * Admin allowlist helpers.
 *
 * Configure via env vars (recommended):
 * - REACT_APP_ADMIN_EMAILS="a@b.com,c@d.com"
 * - REACT_APP_ADMIN_UIDS="uid1,uid2"
 *
 * You can also hardcode values below if you prefer.
 */

const parseList = (value) =>
  String(value || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

export const ADMIN_EMAILS = [
  ...parseList(process.env.REACT_APP_ADMIN_EMAILS).map((e) => e.toLowerCase()),
  // Add emails here if needed:
  'leongaray012@gmail.com'
];

export const ADMIN_UIDS = [
  ...parseList(process.env.REACT_APP_ADMIN_UIDS),
  // Add UIDs here if needed:
  // 'abc123'
];

export function isAdminUser(user) {
  if (!user) return false;
  const uid = user.uid || '';
  const email = (user.email || '').toLowerCase();
  if (uid && ADMIN_UIDS.includes(uid)) return true;
  if (email && ADMIN_EMAILS.includes(email)) return true;
  return false;
}

